module.exports = __webpack_public_path__ + "fonts/Rubik-Regular.37a4d90.ttf";